<app-card-table
    tableKey="userEditEmploymentsTable"
    [tableTitle]="'user.editUser.labels.employmentsOnServices'"
    [gridData]="$any(store.employments())"
    [columns]="columns"
    translatePrefix="user.editUser.employments."
    [hideCheckboxes]="true"
    (deleteCallbackWithEvent)="deleteEmployment($event)"
    (detailCallback)="employmentDetail($event)"
    (createCallback)="employmentDetail()"
    [showCreate]="canEdit() && isAllowed['user.update']()"
    [showDetail]="canEdit()"
    [showDelete]="canEdit()"
>
    <ng-template pTemplate="employmentTypeName" let-item="item">
        {{ 'user.common.employmentTypes.' + item.employmentTypeName | translate }}
    </ng-template>

    <ng-template pTemplate="serviceName" let-data="data">
        {{ data?.name || '' }}
    </ng-template>

</app-card-table>
